import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyService} from '../services/currency.service';
import {AppState} from '../store/store';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {Serializer} from '../interfaces/serializer';
import {User} from '../interfaces/user';
import {selectUser} from '../store/init/init.selectors';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'appCurrency'
})
export class AppCurrencyPipe implements PipeTransform {
  private readonly _user$: Observable<Serializer<User>> = this._store.select(selectUser);

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _currencyS: CurrencyService
  ) { }

  public transform(value: any, currencyCode: string, decimals: number = 2): Observable<string> {
    return this._user$.pipe(
      map((user: Serializer<User>) => this._currencyS.format(user, value, currencyCode, decimals))
    );
  }

}
